"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VirtualScrollView = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactCustomScrollbars = _interopRequireWildcard(require("react-custom-scrollbars-2"));

var _ = require("../..");

var _hook = require("../../hook");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The flex container with custom scrollbars.
 */
const ScrollView = /*#__PURE__*/React.forwardRef(({
  autoHideScroll = true,
  scrollBarProps,
  children,
  width,
  height,
  autoHeight,
  autoHeightMax,
  autoHeightMin,
  onScrolledToBottom,
  scrollToBottomDebounceDelay = 300,
  scrolledToBottomThreshold = 0.9,
  ...viewProps
}, ref) => {
  const [top, setTop] = (0, _hook.useDebounce)(0, scrollToBottomDebounceDelay);
  const onScrollEnd = React.useCallback(values => {
    setTop(values.top);
  }, [setTop]);
  React.useEffect(() => {
    if (top >= scrolledToBottomThreshold && onScrolledToBottom) {
      onScrolledToBottom();
    }
  }, [top, onScrolledToBottom, scrolledToBottomThreshold]);
  return (0, _pragma.createFelaElement)(_reactCustomScrollbars.default, _extends({
    autoHide: autoHideScroll,
    autoHeight: autoHeight,
    autoHeightMax: autoHeightMax,
    autoHeightMin: autoHeightMin,
    style: {
      width,
      height
    },
    onScrollFrame: onScrollEnd
  }, scrollBarProps, {
    ref: ref
  }), (0, _pragma.createFelaElement)(_.View, _extends({}, viewProps, {
    overflow: "hidden"
  }), children));
});
/**
 * The flex container with custom scrollbars for react-window lists
 */

const VirtualScrollView = /*#__PURE__*/React.forwardRef(({
  children,
  style,
  onScroll,
  onScrolledToBottom,
  scrollToBottomDebounceDelay = 300,
  scrolledToBottomThreshold = 0.9
}, ref) => {
  const [top, setTop] = (0, _hook.useDebounce)(0, scrollToBottomDebounceDelay);
  const onScrollEnd = React.useCallback(values => {
    setTop(values.top);
  }, [setTop]);
  React.useEffect(() => {
    if (top >= scrolledToBottomThreshold && onScrolledToBottom) {
      onScrolledToBottom();
    }
  }, [top, onScrolledToBottom, scrolledToBottomThreshold]);
  return (0, _pragma.createFelaElement)(_reactCustomScrollbars.default, {
    ref: ref,
    style: { ...style,
      overflow: 'hidden'
    },
    onScroll: onScroll,
    onScrollFrame: onScrollEnd,
    autoHide: true
  }, children);
});
exports.VirtualScrollView = VirtualScrollView;
ScrollView.displayName = 'ScrollView';
var _default = ScrollView;
exports.default = _default;
//# sourceMappingURL=ScrollView.js.map